import { Sparkles } from 'lucide-react';

const ITEMS = [
  'Residential Cleaning',
  'Office Cleaning',
  'Restaurant Cleaning',
  'Retail Cleaning',
  'Deep Cleaning',
  'Post-Construction Cleaning',
  'Move-In / Move-Out Cleaning',
];

export default function Marquee() {
  return (
    <div
      data-testid="marquee-strip"
      className="relative bg-obsidian border-y border-white/10 py-5 overflow-hidden"
    >
      <div className="flex w-max animate-marquee marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center shrink-0">
            {ITEMS.map((item, i) => (
              <div key={i} className="flex items-center shrink-0">
                <span className="font-display font-semibold text-white/70 text-base sm:text-lg tracking-wide whitespace-nowrap px-8">
                  {item}
                </span>
                <Sparkles size={14} className="text-mint-vibrant shrink-0" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
